import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import store from "@/store/index";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/ui",
        name: "ui",
        component: () => import("@/components/ui/_ui.vue")
    },
    {
        path: "/userProfile",
        name: "UserProfile",
        component: () => import("@/components/users/_UserProfile.vue"),
        meta: {
            breadcrumbs: {
                icon: "profile-icon",
                paths: []
            },
            title: "users.userProfile"
        }
    },
    {
        path: "/applicationSettings",
        name: "ApplicationSettings",
        component: () => import("@/components/applicationSettings/_ApplicationSettings.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateApplicationSettings,
            breadcrumbs: {
                icon: "settings-icon",
                paths: []
            },
            title: "navbar.settings"
        }
    },
    {
        path: "/userActivityLogs",
        name: "userActivityLogs",
        component: () => import("@/components/userActivityLogs/_UserActivityLogs.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetActivityLogs,
            breadcrumbs: {
                icon: "activity-logs-icon",
                paths: []
            },
            title: "navbar.useractivityLogs"
        }
    },
    {
        path: "/support",
        name: "support",
        component: () => import("@/components/support/_Support.vue"),
        props: true,
        meta: {
            breadcrumbs: {
                icon: "phone-icon",
                paths: []
            },
            title: "support.title"
        }
    },
    {
        path: "/media",
        name: "media",
        component: () => import("@/components/files/_Files.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetFiles,
            breadcrumbs: {
                icon: "folder-icon",
                paths: []
            },
            title: "navbar.mediaLibrary"
        }
    },
    {
        path: "/systemFiles",
        name: "SystemFiles",
        component: () => import("@/components/files/_SystemFiles.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetFiles,
            breadcrumbs: {
                icon: "system-files-icon",
                paths: []
            },
            title: "navbar.systemFiles"
        }
    }
];
